<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search"
                        :search-condition="searchCondition"
                        :search-buttons="searchButtonList"
                        :fuzzySearchPlaceholder="fuzzySearchPlaceholder"
                        router-name="/collection/transaction">

      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition"
                    ref="table"
                    :service-function="getVaTransactionList"
                    :first-parameters="getInitParams()"
                    :is-first-automatic-visit="false"
                    router-name="/collection/transaction">
        <template #accountNumber="{row}">
          <div class="account-name">{{row.accountHolderName}}</div>
          <div class="payee-account">{{row.payeeAccount}}</div>
        </template>
      </custom-table>
    </div>
  </div>
</template>
<script>
import { getDictionary } from '@/api/common';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { initWeek, getWeekParams } from '@/utils/tools/time';
import VaTransactionService from '@/views/collection/api/transaction';

export default {
  components: {
    SearchComponent,
    CustomTable,
  },
  data() {
    return {
      fuzzySearchPlaceholder: `${this.$t('message.tableCommon.txnSerialNumber')},${this.$t('message.collection.accountNumber')}`,
      searchCondition: [
        {
          key: ['createTimeStartTime', 'createTimeEndTime'],
          name: 'message.tableCommon.txnTime',
          defValue: initWeek(),
          type: 'date_time',
        },
        {
          key: 'bizType',
          name: 'message.collection.type',
          type: 'select',
          defValue: '',
          options: [],
        },
        {
          key: 'txnStatus',
          name: 'message.tableCommon.txnStatus',
          type: 'select',
          defValue: '',
          options: [],
        },
      ],
      searchButtonList: [
        {
          type: 'download',
          permissionCode: 'collection:transaction:download',
          func: async (param) => {
            if (!this.downloading) {
              this.downloading = true;
              try {
                await this.downloadVaTransaction(param);
                ShowSuccessMessage(this.$t('message.common.downloadTask'));
              } catch (err) {
                //
              }
              this.downloading = false;
            }
          },
        }],
      tableCondition: [
        { // 交易日期
          titleBar: { type: 'text', title: 'message.tableCommon.txnTime' },
          key: 'createTime',
          type: 'text',
        },
        { // 交易号
          titleBar: { type: 'text', title: 'message.tableCommon.txnSerialNumber' },
          key: 'id',
          type: 'text',
        },
        { // 交易类型
          titleBar: { type: 'text', title: 'message.collection.type' },
          key: 'bizType',
          type: 'text',
          textFunc: (row) => {
            return getEnantiomericValue(this.bizTypeList, row.bizType);
          },
        },
        { // 交易账号
          titleBar: { type: 'text', title: 'message.collection.accountNumber' },
          key: 'accountNumber',
          type: 'slot',
        },
        { // 金额
          titleBar: { type: 'text', title: 'message.index.amount' },
          key: 'payinAmount',
          type: 'text',
          textFunc: (row) => {
            return `${row.payinAmount} ${row.payinCurrency}`;
          },
        },
        { // 费用
          titleBar: { type: 'text', title: 'message.settlement.serviceAmount' },
          key: 'payinFee',
          type: 'text',
          textFunc: (row) => {
            return `${row.payinFee} ${row.payinCurrency}`;
          },
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'txnStatus',
          type: 'tag',
          textFunc: (row) => {
            return getEnantiomericValue(this.merPayinStatusList, row.txnStatus);
          },
          tagTypeFunc: (row) => {
            if (row.txnStatus === 'Settled') {
              return 'success';
            } else if (row.txnStatus === 'Rejected') {
              return 'danger';
            } else {
              return 'info';
            }
          },
        },
        { // 操作
          titleBar: { type: 'operations', title: 'message.tableCommon.operation' },
          key: 'operations',
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.see',
              permissionCode: 'collection:transaction:detail',
              func: (data) => {
                this.$router.push({
                  path: '/collection/transaction/view',
                  query: { id: data.id },
                });
              },
            },
          ],
        },
      ],
      downloading: false,
      merPayinStatusList: [],
      bizTypeList: [],
    };
  },
  mounted() {
    getDictionary(['MER_PAYIN_STATUS', 'VA_BIZ_TYPE']).then((res) => {
      this.bizTypeList = initSelectedData(res.VA_BIZ_TYPE);
      this.merPayinStatusList = initSelectedData(res.MER_PAYIN_STATUS);
      if (this.$refs.search) {
        this.$refs.search.setSearchSelectOptions('bizType', this.bizTypeList);
        this.$refs.search.setSearchSelectOptions('txnStatus', this.merPayinStatusList);
      }

      this.$refs.table.firstVisitHttp();
    }).catch(() => {
    });
  },
  methods: {
    ...VaTransactionService,
    getInitParams() {
      const params = getWeekParams('createTimeStartTime', 'createTimeEndTime');
      return params;
    },
  },
};
</script>
<style lang="scss" scoped>
.table-wrapper {
  ::v-deep .account-name {
    font-size: 14px;
    font-weight: 800;
    line-height: 32px;
  }
  ::v-deep .payee-account {
    font-size: 14px;
    font-weight: normal;
    line-height: 32px;
  }
}
</style>
